<template>
    <div class="widget-action-bar">
        <div>
            <transition-group name="action-bar-transition">
                <div v-if="actions.length">
                    <ActionButton
                        v-for="(button, index) in actions"
                        :key="index"
                        :loading="button.loading"
                        :disabled="button.disabled"
                        :secondary="button.secondary"
                        :fetching="button.fetching"
                        :label="button.label"
                        :data-testid="button.testId || `widget-action-button-${index}`"
                        @click="button.callback"
                    />
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Action } from '@/types'
import components from 'widget-components'

const { ActionButton } = components

defineProps<{
    actions: Action[]
}>()
</script>

<style lang="scss" scoped>
.widget-action-bar {
    transition: ease-in-out all .3s;
    position: relative;
    z-index: 10;
    background: var(--tl-widget-background-color, var(--color-white, #fff));
    padding-top: 12px;
    .button-action {
        margin-top: 14px;
        &:first-child {
            margin-top: 0px;
        }
    }
}
</style>
